/*class ProductBuyButtons extends HTMLElement{constructor(){super()}connectedCallback(){this.button_container=this.querySelector(".product-buy-buttons--primary"),this.button_text=this.querySelector(".product-buy-buttons--cta-text"),this.form=this.querySelector(".product-buy-buttons--form"),this.root=this.closest(`[data-product-id='${this.dataset.id}']`),this.select_input=this.querySelector(".product-buy-buttons--select"),this.smart_button=this.querySelector(".product-buy-buttons--smart"),this.primary_button=this.querySelector(".product-buy-buttons--cta"),this.addToCartListener(),this.updateViewListener()}addToCartListener(){this.form.on("submit",async t=>{var e,s=t.target,a=theme.utils.getAvailableQuantity(s);"drawer"!==theme.settings.cart_type&&!1!==a||(t.preventDefault(),t.stopPropagation()),a&&this.button_container.setAttribute("data-loading",!0),"drawer"===theme.settings.cart_type&&a&&(e=await theme.cart.addItem(s),this.button_container.setAttribute("data-loading",!1),e)&&(await theme.cart.updateAllHtml(),this.addProductComplete())})}addProductComplete(){theme.off_canvas.toggleView("cart"),"closed"===theme.off_canvas.state&&(theme.off_canvas.openRight(),theme.off_canvas.last_trigger=this.primary_button)}updateViewListener(){window.on("theme:product:variantChanged",({detail:{section:t,variant:e}})=>{var s;t===this.root&&((s=this.select_input.querySelector("option[selected]"))&&s.removeAttribute("selected"),e&&e.available?(this.selectVariant(e.id),this.updateView(!0,!0)):e&&!e.available?(this.selectVariant(e.id),this.updateView(!1,!0)):this.updateView(!1,!1))})}selectVariant(t){this.select_input.querySelector(`option[value='${t}']`).setAttribute("selected",!0)}updateView(t,e){t?(this.primary_button.removeAttribute("disabled"),this.button_text.innerText=theme.translations.add_to_cart,this.smart_button&&(this.smart_button.style.display="block")):(this.primary_button.setAttribute("disabled",!0),this.smart_button&&(this.smart_button.style.display="none"),this.button_text.innerText=e?theme.translations.out_of_stock:theme.translations.unavailable)}}const productBuyButtonsEl=customElements.get("product-buy-buttons-root");productBuyButtonsEl||customElements.define("product-buy-buttons-root",ProductBuyButtons);*/

class ProductBuyButtons extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
   
    this.ensureFormStructure();
        
        (this.button_container = this.querySelector(".product-buy-buttons--primary")),
            (this.button_text = this.querySelector(".product-buy-buttons--cta-text")),
            (this.form = this.querySelector(".product-buy-buttons--form")),
            (this.root = this.closest(`[data-product-id='${this.dataset.id}']`)),
            (this.select_input = this.querySelector(".product-buy-buttons--select")),
            (this.smart_button = this.querySelector(".product-buy-buttons--smart")),
            (this.primary_button = this.querySelector(".product-buy-buttons--cta")),
            this.addToCartListener(),
            this.updateViewListener();
    }

    ensureFormStructure() {
        const formWrapper = this.querySelector(".product-buy-buttons--form-wrapper");
        
        if (!formWrapper) {
            return; 
        }

      
        const existingForm = formWrapper.querySelector(".product-buy-buttons--form");
        
        if (existingForm) {
            return; 
        }

       
        const newForm = document.createElement("form");
        newForm.className = "product-buy-buttons--form";
        newForm.action = "/cart/add";
        newForm.method = "post";
        newForm.enctype = "multipart/form-data";

     
        const children = Array.from(formWrapper.children);

  
        children.forEach(child => {
            newForm.appendChild(child);
        });

     
        formWrapper.appendChild(newForm);
    }

    addToCartListener() {
        this.form.on("submit", async (t) => {
            var e,
                s = t.target,
                a = theme.utils.getAvailableQuantity(s);
            ("drawer" !== theme.settings.cart_type && !1 !== a) || (t.preventDefault(), t.stopPropagation()),
                a && this.button_container.setAttribute("data-loading", !0),
                "drawer" === theme.settings.cart_type && a && ((e = await theme.cart.addItem(s)), this.button_container.setAttribute("data-loading", !1), e) && (await theme.cart.updateAllHtml(), this.addProductComplete());
        });
    }

    addProductComplete() {
        theme.off_canvas.toggleView("cart"), "closed" === theme.off_canvas.state && (theme.off_canvas.openRight(), (theme.off_canvas.last_trigger = this.primary_button));
    }

    updateViewListener() {
        window.on("theme:product:variantChanged", ({ detail: { section: t, variant: e } }) => {
            var s;
            t === this.root &&
                ((s = this.select_input.querySelector("option[selected]")) && s.removeAttribute("selected"),
                e && e.available ? (this.selectVariant(e.id), this.updateView(!0, !0)) : e && !e.available ? (this.selectVariant(e.id), this.updateView(!1, !0)) : this.updateView(!1, !1));
        });
    }

    selectVariant(t) {
        this.select_input.querySelector(`option[value='${t}']`).setAttribute("selected", !0);
    }

    updateView(t, e) {
        t
            ? (this.primary_button.removeAttribute("disabled"), (this.button_text.innerText = theme.translations.add_to_cart), this.smart_button && (this.smart_button.style.display = "block"))
            : (this.primary_button.setAttribute("disabled", !0), this.smart_button && (this.smart_button.style.display = "none"), (this.button_text.innerText = e ? theme.translations.out_of_stock : theme.translations.unavailable));
    }
}

const productBuyButtonsEl = customElements.get("product-buy-buttons-root");
productBuyButtonsEl || customElements.define("product-buy-buttons-root", ProductBuyButtons);